import { ErrorTrackingClient } from '@squareup/service-error-tracking';

export const TEAM = 'banking-team';

export enum TeamType {
  CashFlow = 'cash-flow',
  Credit = 'credit',
}

const client = new ErrorTrackingClient();

export default client;
